import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import EmailMarketingQuizContainer from "./EmailMarketingQuizContainer";
import EmailMarketingResults from "./EmailMarketingResults";

const EmailMarketingQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UserInfoForm
            subtitle="Build Campaigns That Convert"
            onSubmit={handleUserInfoSubmit}
          />
        }
      />
      <Route
        path="quiz"
        element={<EmailMarketingQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<EmailMarketingResults />} />
    </Routes>
  );
};

export default EmailMarketingQuiz;
